export enum StatistiquesPath{
    BPF = 'bpf'
}
